export default Object.freeze({
  Pending: 1,
  Processing: 2,
  Processed: 3,
  Error: 4,
  Skipped: 5,
  Cancelled: 6,
  Failed: 7,
  /** Additive — AI Agent Schedule tasks (Resume/Run only). */
  Paused: 8,
});
